import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.23438 8.50006C1.23438 4.76294 4.26391 1.7334 8.00104 1.7334C11.7382 1.7334 14.7677 4.76294 14.7677 8.50006C14.7677 12.2372 11.7382 15.2667 8.00104 15.2667C4.26391 15.2667 1.23438 12.2372 1.23438 8.50006ZM10.7103 7.61468C11.0143 7.40705 11.0925 6.99224 10.8849 6.68818C10.6772 6.38412 10.2624 6.30595 9.95836 6.51358L9.89083 6.55969C8.79691 7.30668 7.85396 8.2496 7.10827 9.33836L6.1388 8.36991C5.87831 8.1097 5.4562 8.10993 5.19599 8.37041C4.93578 8.6309 4.936 9.05301 5.19649 9.31322L6.75729 10.8724C6.90421 11.0191 7.11115 11.089 7.31699 11.0615C7.52283 11.0339 7.70405 10.9119 7.80715 10.7317C8.50774 9.50662 9.4773 8.45661 10.6427 7.66079L10.7103 7.61468Z",
		fill: "currentColor"
	})
});
export default SvgCheckCircle;
